import type { EditorState } from "@tiptap/pm/state";

// split input by open or close punctuation or whitespaces
// but keep adjacent pairs like () [] {} together as single tokens
const INPUT_SPLIT_RE = /(\p{Ps}\p{Pe}|\p{Ps}|\p{Pe}|\s)/gu;

export function getInputPosition(
  state: EditorState,
  allowRangeSelection = false,
): [number, number, string] {
  const from = state.selection.$head.pos;
  const to = state.selection.$anchor.pos;

  let start = Math.min(from, to);
  let end = Math.max(from, to);
  let value = "";

  const isRangeSelection = allowRangeSelection && from !== to;

  if (isRangeSelection) {
    return [start, end, state.doc.textBetween(start, end) || ""];
  }

  const { nodeBefore, pos } = state.selection.$from;

  if (nodeBefore?.text) {
    const textItemsBefore = nodeBefore.text.split(INPUT_SPLIT_RE).filter(Boolean) || [];
    value = textItemsBefore.at(-1) || "";

    const offset = nodeBefore.text.lastIndexOf(value);
    start = pos - nodeBefore.text.length + offset;
    end = pos;
  }

  return [start, end, value];
}
